import {Component, input} from '@angular/core';
import {Animal} from "src/app/infrastructure/moovement-api/models/asset";
import {AnimalSvgComponent} from "src/app/presentation/common/icons/animal-svg/animal-svg.component";
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-animal-profile-picture',
  imports: [
    AnimalSvgComponent,
    NgClass
],
  templateUrl: './animal-profile-picture.component.html',
  styleUrl: './animal-profile-picture.component.css'
})
export class AnimalProfilePictureComponent {

  animal = input<Animal | undefined>();
  clickable = input(false);
  alter = input(false);
}
